import { PageId } from 'constants/pages'

export const enum PageIdStylioArch81 {
  SUBSCRIPTIONS_ARCH_81 = PageId.SUBSCRIPTIONS_ARCH_81,
  SUB_UPSELL_ARCH_81 = PageId.SUB_UPSELL_ARCH_81,
  FACE_STYLING_PDF_UPSELL_ARCH_81 = PageId.FACE_STYLING_PDF_UPSELL_ARCH_81,
  PROPORTIONS_PDF_UPSELL_ARCH_81 = PageId.PROPORTIONS_PDF_UPSELL_ARCH_81,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_ARCH_81 = PageId.DOWNLOAD_ARCH_81,
}
